/* Kosei Art product inquiry links and contact-page context.
 * This asset deliberately leaves Shopify's native contact form submission intact.
 */
(function () {
  'use strict';

  if (window.__koseiProductInquiryLoaded) return;
  window.__koseiProductInquiryLoaded = true;

  var isJapanese = (document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ja';
  var MAX_TEXT_LENGTH = 240;
  var MAX_URL_LENGTH = 2048;

  function safeText(value) {
    if (typeof value !== 'string') return '';
    var text = value.replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
    if (!text || text.length > MAX_TEXT_LENGTH || /[<>]/.test(text)) return '';
    return text;
  }

  function normalizeStoreRoot(value) {
    try {
      var url = new URL(value || '/', window.location.origin);
      if (url.origin !== window.location.origin) return '/';
      var path = url.pathname || '/';
      return path.charAt(path.length - 1) === '/' ? path : path + '/';
    } catch (error) {
      return '/';
    }
  }

  function safeProductUrl(value, storeRoot) {
    if (typeof value !== 'string' || !value || value.length > MAX_URL_LENGTH) return '';

    try {
      var url = new URL(value, window.location.origin);
      var productPath = normalizeStoreRoot(storeRoot) + 'products/';
      if (url.origin !== window.location.origin || url.pathname.indexOf(productPath) !== 0) return '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function contactUrl(value, storeRoot) {
    var contactPath = normalizeStoreRoot(storeRoot) + 'pages/contact';
    try {
      var url = new URL(value || contactPath, window.location.origin);
      if (url.origin === window.location.origin && (url.pathname === contactPath || url.pathname === contactPath + '/')) {
        return url;
      }
    } catch (error) {
      // Use the store's contact page below.
    }
    return new URL(contactPath, window.location.origin);
  }

  function cleanProductLink(value) {
    try {
      var url = new URL(value);
      var variantId = url.searchParams.get('variant');
      url.search = '';
      url.hash = '';
      if (/^\d+$/.test(variantId || '')) url.searchParams.set('variant', variantId);
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function variantsFor(link) {
    try {
      var variants = JSON.parse(link.dataset.productVariants || '[]');
      if (!Array.isArray(variants)) return [];
      return variants.filter(function (variant) {
        return variant && (typeof variant.id === 'string' || typeof variant.id === 'number');
      });
    } catch (error) {
      return [];
    }
  }

  function selectedVariant(link) {
    var formId = link.dataset.productForm;
    var form = formId ? document.getElementById(formId) : null;
    var input = form && form.querySelector('[name="id"]');
    var candidateId = input && input.value ? String(input.value) : '';
    var id = /^\d+$/.test(candidateId) ? candidateId : '';
    var title = '';

    if (id) {
      variantsFor(link).some(function (variant) {
        if (String(variant.id) === id) {
          title = safeText(String(variant.title || ''));
          return true;
        }
        return false;
      });
    }

    return { id: id, title: title };
  }

  function refreshInquiryLink(link) {
    if (!link || !link.classList || !link.classList.contains('kosei-product-inquiry')) return;

    var storeRoot = normalizeStoreRoot(link.dataset.storeRoot || '/');
    var product = safeText(link.dataset.productTitle || '');
    var productUrl = safeProductUrl(link.dataset.productUrl || '', storeRoot);
    if (!product || !productUrl) return;

    var variant = selectedVariant(link);
    var selectedProductUrl = new URL(productUrl);
    if (variant.id) {
      selectedProductUrl.searchParams.set('variant', variant.id);
    } else {
      selectedProductUrl.searchParams.delete('variant');
    }
    var destination = contactUrl(link.dataset.contactUrl || link.getAttribute('href'), storeRoot);
    destination.searchParams.set('product', product);
    destination.searchParams.set('variant_id', variant.id);
    destination.searchParams.set('product_url', selectedProductUrl.href);

    if (variant.title && variant.title.toLowerCase() !== 'default title') {
      destination.searchParams.set('variant', variant.title);
    } else {
      destination.searchParams.delete('variant');
    }

    link.setAttribute('href', destination.href);
  }

  function refreshAllInquiryLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.kosei-product-inquiry').forEach(refreshInquiryLink);
  }

  function eventInquiryLink(event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.kosei-product-inquiry') : null;
    if (link) refreshInquiryLink(link);
  }

  function refreshFormLinks(event) {
    var target = event.target;
    var form = target && target.closest ? target.closest('form') : null;
    if (!form || !form.id) return;
    document.querySelectorAll('.kosei-product-inquiry[data-product-form]').forEach(function (link) {
      if (link.dataset.productForm === form.id) refreshInquiryLink(link);
    });
  }

  function initializeContactContext() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var metadata = {
      product: document.getElementById('ContactForm-product'),
      variant: document.getElementById('ContactForm-variant'),
      productUrl: document.getElementById('ContactForm-product-url')
    };
    Object.keys(metadata).forEach(function (key) {
      if (!metadata[key]) return;
      metadata[key].value = '';
      metadata[key].disabled = true;
    });

    var params = new URLSearchParams(window.location.search);
    var context = document.querySelector('[data-kosei-inquiry-context]');
    var storeRoot = normalizeStoreRoot(context && context.dataset.storeRoot);
    var product = safeText(params.get('product') || '');
    var variant = safeText(params.get('variant') || '');
    var productUrl = safeProductUrl(params.get('product_url') || '', storeRoot);
    if (!product || !productUrl) return;

    var title = document.querySelector('[data-kosei-inquiry-title]');
    var displayName = product;
    if (variant && variant.toLowerCase() !== 'default title') displayName += (isJapanese ? ' / ' : ' — ') + variant;

    if (title) title.textContent = displayName;
    if (context) context.hidden = false;

    var cleanedProductUrl = cleanProductLink(productUrl);
    if (metadata.product) {
      metadata.product.value = product;
      metadata.product.disabled = false;
    }
    if (metadata.variant) {
      metadata.variant.value = variant || 'Default Title';
      metadata.variant.disabled = false;
    }
    if (metadata.productUrl) {
      metadata.productUrl.value = cleanedProductUrl;
      metadata.productUrl.disabled = false;
    }

    var body = document.getElementById('ContactForm-body');
    if (!body || String(body.value || '').trim()) return;

    body.value = isJapanese
      ? displayName + 'について問い合わせます。\n\nお問い合わせ内容：\n\nお届け先の国・都市：'
      : "I'm interested in " + displayName + '.\n\nMy question:\n\nDelivery country/city: ';
  }

  function initialize() {
    refreshAllInquiryLinks(document);
    initializeContactContext();
  }

  document.addEventListener('change', refreshFormLinks, true);
  document.addEventListener('pointerdown', eventInquiryLink, true);
  document.addEventListener('click', eventInquiryLink, true);
  document.addEventListener('auxclick', eventInquiryLink, true);
  document.addEventListener('contextmenu', eventInquiryLink, true);
  document.addEventListener('focusin', eventInquiryLink, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') eventInquiryLink(event);
  }, true);
  document.addEventListener('shopify:section:load', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
